import React from 'react'
import { useSelector } from 'react-redux'
import { Overlay, Spinner } from '@blueprintjs/core'

import { OverlayBody } from './styled'

export default function Loading(props) {
  const loading = useSelector(state => state.app.loading)
  const loadingMsg = useSelector(state => state.app.loadingMsg)

  return (
    <Overlay styled={{ zIndex: 1001 }} isOpen={loading}>
      <OverlayBody>
        <Spinner size={65} styled={{ stroke: '#FBBF66 !important;' }} />
        {loadingMsg || 'Loading'}
      </OverlayBody>
    </Overlay>
  )
}